import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV, IMAGES } from "../../data/km";

export const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

export default function KMHeader({ onConnect }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 30);
    on(); window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);
  const nav = useNavigate();
  const { pathname } = useLocation();
  const go = (id) => {
    setOpen(false);
    const item = NAV.find((n) => n.id === id);
    if (item?.to) return nav(item.to);
    if (pathname !== "/") nav(`/#${id}`); else scrollTo(id);
  };
  const home = () => { setOpen(false); if (pathname !== "/") nav("/"); else window.scrollTo({ top: 0, behavior: "smooth" }); };
  return (
    <header className={`fixed inset-x-0 top-0 z-50 bg-white transition-shadow duration-300 ${scrolled ? "shadow-[0_1px_14px_rgba(0,0,0,0.07)]" : ""}`} data-testid="km-header">
      <div className="w-full mx-auto px-5 md:px-10 lg:px-14 h-[76px] md:h-[84px] flex items-center justify-between">
        <button onClick={home} className="text-left shrink-0" aria-label="Kristin McIntyre home" data-testid="km-logo">
          <img src={IMAGES.logoBlack} alt="eXp Realty Luxury" className="h-8 md:h-10 w-auto" data-testid="km-header-exp-logo" />
        </button>
        <nav className="hidden min-[1440px]:flex items-center gap-5 2xl:gap-8">
          {NAV.map((n) => <button key={n.id} onClick={() => go(n.id)} className="km-nav whitespace-nowrap" data-testid={`km-nav-${n.id}`}>{n.label}</button>)}
          <button onClick={onConnect} className="km-btn-dark" data-testid="km-header-connect">Let's Connect</button>
        </nav>
        <div className="min-[1440px]:hidden flex items-center gap-2">
          <button onClick={onConnect} className="km-btn-dark !min-w-0 !px-4 !py-3 !text-[10px]" data-testid="km-mobile-connect">Let's Connect</button>
          <button className="p-3 -mr-2" onClick={() => setOpen(!open)} aria-label="Menu" aria-expanded={open} data-testid="km-mobile-menu-btn">{open ? <X size={22} strokeWidth={1.2} /> : <Menu size={22} strokeWidth={1.2} />}</button>
        </div>
      </div>
      <div className={`min-[1440px]:hidden grid transition-all duration-500 bg-white ${open ? "grid-rows-[1fr] border-t border-black/5" : "grid-rows-[0fr]"}`}>
        <div className="overflow-hidden">
          <div className="flex flex-col px-6 py-4">
            {NAV.map((n) => <button key={n.id} onClick={() => go(n.id)} className="km-nav text-left py-4 border-b border-black/5" data-testid={`km-mobile-nav-${n.id}`}>{n.label}</button>)}
          </div>
        </div>
      </div>
    </header>
  );
}
